// extracted by mini-css-extract-plugin
export default {"upload_image":"Upload_upload_image__Mf5ZZ"};